import dayjs from "dayjs";
import { TFunction } from "i18next";
import { formatNumber } from "../../../../../../common/utils";
import { ThirdPartyTripDetailsDTO } from "../../../../../../datasources/api-client/data-contracts";
import { DisplayItem, item, itemMV, safeLabel } from "../../../../utils";

export const displayValuesThirdParty = (data: ThirdPartyTripDetailsDTO | undefined, t: TFunction, lang: string) => {
	if (!data) {
		return {
			emissions: [] as DisplayItem[],
			transportData: [] as DisplayItem[],
		};
	}

	const transportData: DisplayItem[] = [
		item(t("source emission"), data.sourceLabel),

		item(
			t("period"),
			data.from && data.to
				? `${dayjs(data.from).format("DD/MM/YYYY")} - ${dayjs(data.to).format("DD/MM/YYYY")}`
				: "-"
		),

		item(t("methodology"), data.methodologyLabel),
		item(t("isCertified"), data.isCertified ? t("yes") : t("no")),

		itemMV(t("distance"), data.distance),
		itemMV(t("weight"), data.weight),

		item(t("scope"), data.scope, true),
		item(t("scope category"), safeLabel(data.scopeCategoryLabel, data.scopeCategoryId), true),

		itemMV(`${t("emission scope")} 1 (tCO2e)`, data.emissionsScope1),
		itemMV(`${t("emission scope")} 2 (tCO2e)`, data.emissionsScope2),
		itemMV(`${t("emission scope")} 3 (tCO2e)`, data.emissionsScope3),

		itemMV(`${t("emission")} Ttw (tCO2e)`, data.emissionsTtw),
		itemMV(`${t("emission")} Wtw (tCO2e)`, data.emissionsWtw),

		itemMV(`${t("energy consumed")} Wtw (GJ)`, data.energy),
		itemMV(t("marketbase emissions"), data.marketBasedEmissions),

		itemMV(`${t("emissions")} CO2`, data.co2),
		itemMV(`${t("emissions")} CH4`, data.ch4),
		itemMV(`${t("emissions")} N2O`, data.n2o),
		itemMV("PMx", data.pmx),

		item(t("source year"), data.sourceYear, true),
		itemMV("Tkm", data.tkm),
		itemMV(t("f"), data.volume),

		item(t("type packaging"), safeLabel(data.packageLabel, data.packageId), true),
		item(t("type quantity"), data.packageQty ? formatNumber(data.packageQty, "decimal", 2) : "-", true),

		item(t("start country"), data.startCountry, true),
		item(t("start city"), data.startCity, true),
		item(t("start node code"), data.startNodeCode, true),

		item(t("end country"), data.endCountry, true),
		item(t("end city"), data.endCity, true),
		item(t("end node code"), data.endNodeCode, true),

		item(t("flight number"), data.flightNumber, true),
		item(t("vessel number"), data.vesselNumber, true),

		item(t("incoterms"), safeLabel(data.incotermLabel, data.incotermId), true),

		item(t("trast id"), data.transportTypeId?.toString(), true),
		/* 		item(t("energy carier ?"), "to do", true),
		 */
		item(t("sturation"), data.saturation, true),
		itemMV(t("empty distance"), data.emptyDistance),

		item(t("refrigerant"), safeLabel(data.refrigerantLabel, data.refrigerantId), true),
		item(t("temperature"), safeLabel(data.temperatureLabel, data.temperatureId), true),

		item(t("transport type"), safeLabel(data.tripTypeLabel, data.tripTypeId), true),
		item(t("flight type"), safeLabel(data.flightTypeLabel, data.flightTypeId), true),

		item(t("insert date"), data.insertDate ? dayjs(data.insertDate).format("DD/MM/YYYY") : "-", true),

		item(t("description"), data.description, true),
		item(t("id import"), data.importCode, true),
	];

	const emissions: DisplayItem[] = [
		/* 		itemMV(t("transport emissions"), data.emissionsTransport),
		 */ itemMV(t("hub emissions"), data.emissionshub),
		itemMV(t("intensity emissions"), data.emissionsIntensity),
		itemMV(t("biogenic emissions"), data.emissionsBio),
	];

	return { emissions, transportData };
};
